import { Injectable } from '@angular/core';

@Injectable()

export class ConfigService {
  //serverIp = 'http://192.168.1.65:1337';
  serverIp = 'https://api-jpcargo.logisticscargo.net';
//  serverIp = 'http://localhost:1337';
  constructor() {}
}
